import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import PublicBlankLayoutView from 'components/layouts/PublicBlankLayout'

export default compose(
  withRouter,
)(PublicBlankLayoutView)
